import React, { useState } from 'react';

import { Button, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ZOOM_LOGIN_REDIRECT_PATH } from '../../config/apiPaths';
import ZoomLogo from '../../icons/ZoomLogo';
import { createOauthState, parseOauthState } from '../../utils/oauthState';
import { getUrls } from '../../utils/url';

const ZoomButton = styled(Button)`
    position: relative;
    width: 100%;
    padding: 0.75rem;
    border-radius: 0;
    margin-bottom: 1rem;
    font-size: 16px;
`;

const StyledZoomLogo = styled(ZoomLogo)`
    position: absolute;
    top: auto;
    bottom: auto;
    width: 30px;
    left: 0.9rem;
`;

const OauthButtonProgress = styled(CircularProgress)`
    position: absolute;
    right: 14px;
`;

export interface ZoomLoginButtonProps {}

const ZoomLoginButton: React.FC<ZoomLoginButtonProps> = () => {
    const { api } = getUrls();
    const { t } = useTranslation('login');

    const [loading, setLoading] = useState(false);

    const handleLoginRedirect = () => {
        setLoading(true);

        const params = new URLSearchParams({
            state: JSON.stringify(parseOauthState() || createOauthState())
        });

        window.location.href = `${api}${ZOOM_LOGIN_REDIRECT_PATH}?${params.toString()}`;
    };

    return (
        <ZoomButton disabled={loading} variant="outlined" onClick={() => handleLoginRedirect()}>
            <StyledZoomLogo />
            {t('sign-in-zoom')}
            {loading && <OauthButtonProgress size={30} />}
        </ZoomButton>
    );
};

export default ZoomLoginButton;
